import { render, staticRenderFns } from "./Ability.vue?vue&type=template&id=b9a826f4&scoped=true&"
import script from "./Ability.vue?vue&type=script&lang=js&"
export * from "./Ability.vue?vue&type=script&lang=js&"
import style0 from "./Ability.vue?vue&type=style&index=0&id=b9a826f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a826f4",
  null
  
)

export default component.exports